import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <header className="header-bar">
      <div className="logo">
        <span className="logo-icon">🚢</span> Maintenance Prediction
      </div>
      <nav className="nav-links">
        <a href="ShipMaintenanceTable.js">Table</a>
        <a href="#about">About</a>
        <a href="#contact">Contact</a>
      </nav>
    </header> 
  );
};

export default Header;
